var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTenantLostFound(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_3669134_find_in_page_ic_icon",
    "data-name": "3669134_find_in_page_ic_icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.261,
    height: 27.261,
    viewBox: "0 0 27.261 27.261",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_6205",
    "data-name": "Path 6205",
    d: "M0,0H27.261V27.261H0Z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6206",
    "data-name": "Path 6206",
    d: "M25.147,22.845V10.43L18.717,4H10.143A2.134,2.134,0,0,0,8.011,6.143L8,23.29a2.134,2.134,0,0,0,2.133,2.143H23A2.1,2.1,0,0,0,24.273,25L19.52,20.252a5.284,5.284,0,0,1-2.947.895,5.364,5.364,0,1,1,4.469-2.406ZM13.358,15.788a3.215,3.215,0,1,0,3.215-3.215A3.218,3.218,0,0,0,13.358,15.788Z",
    transform: "translate(-3.457 -1.728)",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTenantLostFound);
export default __webpack_public_path__ + "static/media/tenant_lost_found.541a4d01c71355abc54757d9edf39ae5.svg";
export { ForwardRef as ReactComponent };